import {
  ESTATUS_TIMBRADO_SIN_TIMBRAR,
  ESTATUS_TIMBRADO_CON_ERROR,
  ESTATUS_TIMBRADO_TIMBRADO_PARCIAL,
  ESTATUS_TIMBRADO_TIMBRADO,
  ESTATUS_TIMBRADO_CANCELADO,
  ESTATUS_TIMBRADO_EN_BUZON,
  ESTATUS_TIMBRADO_PENDIENTE_CONCILIAR,
} from 'utils/constants';

// Color neutro de antd Tag: se usa para Sin Timbrar y para cualquier id que no esté mapeado
export const COLOR_ESTATUS_TIMBRADO_NEUTRO = 'default';

const COLORES_ESTATUS_TIMBRADO = {
  [ESTATUS_TIMBRADO_SIN_TIMBRAR]: COLOR_ESTATUS_TIMBRADO_NEUTRO,
  [ESTATUS_TIMBRADO_CON_ERROR]: 'red',
  [ESTATUS_TIMBRADO_TIMBRADO_PARCIAL]: 'orange',
  [ESTATUS_TIMBRADO_TIMBRADO]: 'green',
  [ESTATUS_TIMBRADO_CANCELADO]: '#8c8c8c',
  [ESTATUS_TIMBRADO_EN_BUZON]: 'blue',
  [ESTATUS_TIMBRADO_PENDIENTE_CONCILIAR]: 'purple',
};

// Ayuda del estatus Pendiente de Conciliar (ticket 15): no es Timbrado ni un error reintentable
export const AYUDA_PENDIENTE_CONCILIAR = 'No se pudo confirmar si este recibo se timbró. '
  + 'No lo vuelva a timbrar: el área responsable lo concilia con el proveedor.';

const AYUDAS_ESTATUS_TIMBRADO = {
  [ESTATUS_TIMBRADO_PENDIENTE_CONCILIAR]: AYUDA_PENDIENTE_CONCILIAR,
};

/**
 * Presentación visual de un estatus de timbrado.
 * El texto siempre sale del catálogo del backend (fuente de verdad); el color, de las
 * constantes ESTATUS_TIMBRADO_*. Un id sin color mapeado (p. ej. un estatus nuevo del
 * backend) se muestra neutro con su descripción. Sin descripción, el texto es '—'.
 * @param {number|null|undefined} id
 * @param {object[]} catalogo tipos de estatus de timbrado ({ id, descripcion })
 * `ayuda` es un texto explicativo para estatus que lo requieren (Pendiente de Conciliar) o null.
 * @returns {{ texto: string, color: string, conDescripcion: boolean, ayuda: string|null }}
 */
export const presentacionEstatusTimbrado = (id, catalogo) => {
  const descripcion = Array.isArray(catalogo)
    ? catalogo.find((e) => e?.id === id)?.descripcion
    : undefined;
  const conDescripcion = typeof descripcion === 'string' && descripcion.trim() !== '';
  return {
    texto: conDescripcion ? descripcion : '—',
    color: COLORES_ESTATUS_TIMBRADO[id] || COLOR_ESTATUS_TIMBRADO_NEUTRO,
    conDescripcion,
    ayuda: AYUDAS_ESTATUS_TIMBRADO[id] || null,
  };
};

// Estatus de nómina con los que Timbrar Todo no tiene nada que enviar: todo Timbrado, o lo
// único pendiente son recibos por conciliar (el backend nunca los reenvía).
const ESTATUS_SIN_NADA_QUE_TIMBRAR = [
  ESTATUS_TIMBRADO_TIMBRADO,
  ESTATUS_TIMBRADO_PENDIENTE_CONCILIAR,
];

/**
 * @param {number|null|undefined} estatusNomina tipo_de_estatus_timbrado del encabezado de la nómina
 * @returns {boolean} true si Timbrar Todo debe ofrecerse habilitado
 */
export const puedeTimbrarTodo = (estatusNomina) => (
  !ESTATUS_SIN_NADA_QUE_TIMBRAR.includes(estatusNomina)
);
